module.exports = __webpack_public_path__ + "img/six_content_item_02.d2a16f20.png";